export default {
  reasonCost: {
    en: 'It\'s more cost effective for me',
  },
  reasonDontNeed: {
    en: 'I don\'t need a scent every month',
  },
  reasonTakesLonger: {
    en: 'It takes me longer than a month to use one scent',
  },
  reasonOther: {
    en: 'Other reason',
  },
  notificationTitle: {
    en: 'Thanks for your feedback!',
  },
}
